import * as React from 'react';
import { useTaskManagerContext } from '../TaskManagerContext';
import { Label } from './TaskFilters.styles';
import { useQueryParam } from 'use-query-params';
import useV2Query from 'utils/useV2Query';
import { GET_ASSIGNED_SPECIALISTS } from 'task-manager/queries';

type AssigneeFilterProps = {
  handleSelectChange: (value: string | null, name: string) => void;
};

export const AssigneeFilter = ({ handleSelectChange }: AssigneeFilterProps) => {
  const [assignedPersonId] = useQueryParam<number | null | undefined>('assignedPersonId');
  const { loggedInPerson } = useTaskManagerContext();

  const handleUndefinedOption = (option?: number) => (option === undefined ? 'All' : option);

  // Query assigned bookkeepers for the Assignment dropdown
  const {
    data: assignedSpecialistsData,
    loading: assignedSpecialistsLoading,
    refetch: assignedSpecialistsRefetch,
  } = useV2Query(GET_ASSIGNED_SPECIALISTS);

  if (!loggedInPerson) return null;

  return (
    <span key={'assigneeFilter'}>
      <Label>Assignee</Label>
      <select
        aria-label="assignment dropdown"
        name="assignedPersonId"
        value={assignedPersonId === null ? 'unassigned' : handleUndefinedOption(assignedPersonId)}
        onChange={event =>
          handleSelectChange(
            event.target.value === 'unassigned' ? null : event.target.value,
            event.target.name,
          )
        }
        onClick={() => assignedSpecialistsRefetch()}
      >
        <optgroup label={'Quick Filters'}>
          <option value={undefined}>All</option>
          <option value="unassigned">Unassigned</option>
          <option value={loggedInPerson.id}>Assigned to me</option>
        </optgroup>
        <optgroup label={'By Specialist'}>
          {assignedSpecialistsLoading && !assignedSpecialistsData ? (
            <option value={undefined}>Loading...</option>
          ) : (
            assignedSpecialistsData.assignedSpecialists?.map(({ fullName, id }) => (
              <option value={id} key={id}>
                {fullName}
              </option>
            ))
          )}
        </optgroup>
      </select>
    </span>
  );
};
